export default __webpack_public_path__ + "static/media/contact.88fd55a0.webp";